import { entityIdsOf, entityMapOf } from "@/widgets/shared/utils/entity-utils";

export function state() {
  return {
    ids: [],
    places: {},
    selectedIndexes: [],
  };
}

export const mutations = {
  setPlaces(state, { places, preselectedPlaceIds = [] }) {
    const idsToSet = entityIdsOf(places);
    const placesToSet = entityMapOf(places);
    const selectedIndexesToSet = preselectedPlaceIds.map(placeId => idsToSet.indexOf(placeId)).filter(index => index !== -1);
    state.ids = idsToSet;
    state.places = placesToSet;
    state.selectedIndexes = selectedIndexesToSet;
  },

  selectByIndex(state, index) {
    state.selectedIndexes = index;
  },
};

export const actions = {};

export const getters = {
  placeById: (state, getters) => id => getters.filteredPlaces[id],

  allPlaces(state, getters) {
    return Object.values(state.places).sort((a, b) => {
      return a.value.localeCompare(b.value);
    });
  },

  filteredPlaces(state, getters, rootState, rootGetters) {
    // const sessions = rootGetters["visibleSessions"];
    // let placesIds = new Set(sessions.map(session => session.tag_agenda_place.id));
    // return getters.allPlaces.filter(place => placesIds.has(place.id));
    return getters.allPlaces;
  },

  selectedPlaceIds(state, getters) {
    const indices = state.selectedIndexes;
    return indices.map(index => getters.filteredPlaces[index]).map(place => place.id);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
